<div class="content-section" [formGroup]="mainForm">
    <div class="form-container">
        <div class="diveristyTypes-container">
            <div class="question">
                <tsl-label class="label" i18n="@@AreYouDiverseSupplier" t="AreYouDiverseSupplier">Are you a diverse Supplier?</tsl-label>
                <tsl-radio-group class="radio-group-example" formControlName="IsDiversityOwned">
                    <tsl-radio-button value="Yes"><span i18n="@@Yes" t="Yes">Yes</span></tsl-radio-button>
                    <tsl-radio-button value="No"><span i18n="@@No" t="No">No</span></tsl-radio-button>
                </tsl-radio-group>
                <tsl-error *ngIf="controls.IsDiversityOwned?.touched && !controls.IsDiversityOwned?.valid"
                    class="text-left" i18n="@@434f8f6235a970107568236f8a35a307dddd13e0" t="434f8f6235a970107568236f8a35a307dddd13e0">
                    This field is required.
                </tsl-error>
            </div>
            <div class="pad-left-25" *ngIf="controls?.IsDiversityOwned?.value == 'Yes'">
                <div class="divesity-types">
                    <!-- Diversity types -->
                    <div class="form-group col-spacing">
                        <!-- <tsl-label class="label">Eligibility Type (Check all that apply)</tsl-label> -->
                        <div formArrayName="DiversityTypes"
                            *ngFor="let type of controls.DiversityTypes?.controls; let i = index;">
                            <div [formGroupName]="i">
                                <tsl-checkbox formControlName="selected">{{type.get('data').value.Code}} -
                                    {{translate.get(type.get('data').value.Name)}}</tsl-checkbox>
                                <div class="pad-left-25">
                                    <input *ngIf="type.get('data').value.Code == 'SDV' && type?.value?.selected"
                                        class="text-area" type="number" tslInput max="100" maxlength="50" name="OtherCompany"
                                        placeholder="Disability Percentage" tPlaceholder="DisabilityPercentage" i18n-placeholder="@@DisabilityPercentage"
                                        formControlName="percentage" />
                                    <input *ngIf="type.get('data').value.Code == 'OTHER' && type?.value?.selected"
                                        class="text-area" tslInput maxlength="50" name="OtherCompany"
                                        placeholder="Please Explain" tPlaceholder="PleaseExplain" i18n-placeholder="@@PleaseExplain"
                                        formControlName="comment" />
                                </div>
                            </div>
                        </div>
                        <tsl-error *ngIf="controls.DiversityTypes?.touched && !controls.DiversityTypes?.valid"
                            class="text-left" i18n="@@PleaseSelectTypeOfDiversity" t="PleaseSelectTypeOfDiversity">
                            Please select type of diversity.
                        </tsl-error>
                    </div>
                </div>
                <div class="diverse-percentage">
                    <tsl-form-field>
                        <tsl-label class="label" i18n="@@WhatIsOwnershipPercentage" t="WhatIsOwnershipPercentage">What is the Percentage of ownership from diverse individual?
                        </tsl-label>
                        <input tslInput type="number" min="1" max="100" step="0.01"
                            formControlName="OwnershipPercentage" />
                    </tsl-form-field>
                    <tsl-error *ngIf="controls.OwnershipPercentage?.touched && !controls.OwnershipPercentage?.valid"
                            class="text-left" i18n="@@434f8f6235a970107568236f8a35a307dddd13e0" t="434f8f6235a970107568236f8a35a307dddd13e0">
                            This field is required.
                        </tsl-error>
                </div>
            </div>
            <div class="certifications-container">
                <div class="council-certifications-container">
                    <div class="question">
                        <tsl-label class="label" i18n="@@AreYouCertifiedWithCouncilAgency" t="AreYouCertifiedWithCouncilAgency">Are you certified with a council agency?</tsl-label>
                        <tsl-radio-group class="radio-group-example" formControlName="IsCouncilCertified">
                            <tsl-radio-button value="Yes"><span i18n="@@Yes" t="Yes">Yes</span></tsl-radio-button>
                            <tsl-radio-button value="No"><span i18n="@@No" t="No">No</span></tsl-radio-button>
                        </tsl-radio-group>
                        <tsl-error *ngIf="controls.IsCouncilCertified?.touched && !controls.IsCouncilCertified?.valid"
                            class="text-left" i18n="@@434f8f6235a970107568236f8a35a307dddd13e0" t="434f8f6235a970107568236f8a35a307dddd13e0">
                            This field is required.
                        </tsl-error>
                    </div>
                    <div *ngIf="controls?.IsCouncilCertified?.value == 'Yes'">
                        <div class="form-group pad-left-25">
                            <!-- Diversity types -->
                            <div class="form-group col-spacing">
                                <!-- <tsl-label class="label">Council Diversity Certifications (Check all that apply)
                                </tsl-label> -->
                                <div formArrayName="CouncilCertifications"
                                    *ngFor="let type of controls.CouncilCertifications?.controls; let i = index;">
                                    <div [formGroupName]="i">
                                        <tsl-checkbox formControlName="selected"
                                            (change)="onCertificationChange($event)"
                                            [name]="type.get('data').value.DocumentType">{{type.get('data').value.Code}}
                                            -
                                            {{ translate.get(type.get('data').value.Name) }}</tsl-checkbox>
                                        <div class="pad-left-25">
                                            <input
                                                *ngIf="type.get('data').value.Code == 'OTHER' && type?.value?.selected"
                                                class="text-area" tslInput maxlength="50" name="OtherCompany"
                                                placeholder="Please Explain" tPlaceholder="PleaseExplain" i18n-placeholder="@@PleaseExplain"
                                                formControlName="comment" />
                                        </div>
                                    </div>
                                </div>
                                <tsl-error *ngIf="!controls.CouncilCertifications?.valid" class="text-left"
                                    i18n="@@PleaseSelectTypeOfCouncilCertification" t="PleaseSelectTypeOfCouncilCertification">
                                    Please select type of council certification.
                                </tsl-error>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="council-certifications-container">
                    <div class="question">
                        <tsl-label class="label" i18n="@@AreYouCertifiedWithGovernmentAgency" t="AreYouCertifiedWithGovernmentAgency">Are you certified with a Government agency?</tsl-label>
                        <tsl-radio-group class="radio-group-example" formControlName="IsGovtCertified">
                            <tsl-radio-button value="Yes"><span i18n="@@Yes" t="Yes">Yes</span></tsl-radio-button>
                            <tsl-radio-button value="No"><span i18n="@@No" t="No">No</span></tsl-radio-button>
                        </tsl-radio-group>
                        <tsl-error *ngIf="controls.IsGovtCertified?.touched && !controls.IsGovtCertified?.valid"
                            class="text-left" i18n="@@434f8f6235a970107568236f8a35a307dddd13e0" t="434f8f6235a970107568236f8a35a307dddd13e0">
                            This field is required.
                        </tsl-error>
                    </div>
                    <div *ngIf="controls?.IsGovtCertified?.value == 'Yes'">
                        <div class="form-group pad-left-25">
                            <!-- Diversity types -->
                            <div class="form-group col-spacing">
                                <!-- <tsl-label class="label">Government Diversity Certifications (Check all that apply)
                                </tsl-label> -->
                                <div formArrayName="GovtCertifications"
                                    *ngFor="let type of controls.GovtCertifications?.controls; let i = index;">
                                    <div [formGroupName]="i">
                                        <tsl-checkbox formControlName="selected"
                                            (change)="onCertificationChange($event)"
                                            [name]="type.get('data').value.DocumentType">{{type.get('data').value.Code}}
                                            -
                                            {{ translate.get(type.get('data').value.Name) }}</tsl-checkbox>
                                        <div class="pad-left-25">
                                            <input
                                                *ngIf="type.get('data').value.Code == 'OTHER' && type?.value?.selected"
                                                class="text-area" tslInput maxlength="50" name="OtherCompany"
                                                placeholder="Please Explain" tPlaceholder="PleaseExplain" i18n-placeholder="@@PleaseExplain"
                                                formControlName="comment" />
                                        </div>
                                    </div>
                                </div>
                                <tsl-error *ngIf="!controls.GovtCertifications?.valid" class="text-left" 
                                    i18n="@@PleaseSelectTypeOfGovernmentCertification" t="PleaseSelectTypeOfGovernmentCertification">
                                    Please select type of government certification.
                                </tsl-error>
                            </div>
                        </div>
                    </div>
                </div>
                <diversity-document-grid></diversity-document-grid>
            </div>
        </div>
    </div>
</div>
